import { render, staticRenderFns } from "./Options.vue?vue&type=template&id=2cf79f12"
import script from "./Options.vue?vue&type=script&lang=js"
export * from "./Options.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports